import React from 'react';
import { isMobileScreen } from '@apply/ui';
import { Button, ButtonTheme } from '@apply/components';
import { Footer } from '../../common_v2/components/Footer';
import { WizardSidebar } from './WizardSidebar';
import { WizardStepId } from './steps';
import '../scss/_bpwizard.scss';

interface WizardLayoutProps {
    currentStepId: WizardStepId;
    completedStepIds: WizardStepId[];
    onStepClick?: (stepId: WizardStepId) => void;
    onSaveAndExit: () => void;
    title: string;
    titleIcon?: React.ReactNode;
    description?: React.ReactNode;
    children: React.ReactNode;
    footer?: React.ReactNode;
}

export const WizardLayout: React.FC<WizardLayoutProps> = ({
    currentStepId,
    completedStepIds,
    onStepClick,
    onSaveAndExit,
    title,
    titleIcon,
    description,
    children,
    footer,
}) => {
    const mobileScreen = isMobileScreen();

    const saveAndExit = (
        <div style={{ float: 'right' }}>
            <Button
                id='bpWizard-saveAndExitButton'
                dataTestid='bpWizardSaveAndExitButton'
                theme={ButtonTheme.LinkBlue}
                handleClick={onSaveAndExit}
            >
                Save and Exit
            </Button>
        </div>
    );

    const heading = (
        <>
            <div className='pageHeader bpWizard-title'>
                {titleIcon && (
                    <span
                        className='bpWizard-title-icon'
                        aria-hidden='true'
                    >
                        {titleIcon}
                    </span>
                )}
                {title}
            </div>
            {description && <div className='bpWizard-description'>{description}</div>}
        </>
    );

    return (
        <>
            <div className='bpWizard'>
                <div className='bpWizard-container'>
                    {!mobileScreen && (
                        <div className='bpWizard-left'>
                            <aside className='bpWizard-sidebar'>
                                <div className='bpWizard-sidebar-contentWrapper'>
                                    <div className='bpWizard-sidebar-logo'>
                                        <img
                                            src='/assets/img/logo.webp.html'
                                            alt='Builder Finance'
                                            width='116px'
                                        />
                                    </div>
                                    <div className='bpWizard-sidebar-breadcrumb'>
                                        <WizardSidebar
                                            currentStepId={currentStepId}
                                            completedStepIds={completedStepIds}
                                            onStepClick={onStepClick}
                                        />
                                    </div>
                                </div>
                            </aside>
                        </div>
                    )}

                    <div className='bpWizard-right'>
                        {mobileScreen && (
                            <div className='bpWizard-mobileHeader'>
                                <img
                                    src='/assets/img/logo.webp.html'
                                    alt='Builder Finance'
                                    width='96px'
                                />
                                {saveAndExit}
                            </div>
                        )}

                        <div className='bpWizard-appWrapper'>
                            {!mobileScreen && <div className='bpWizard-saveAndExitButtons'>{saveAndExit}</div>}

                            {mobileScreen && (
                                <div className='bpWizard-mobileBreadcrumb'>
                                    <WizardSidebar
                                        currentStepId={currentStepId}
                                        completedStepIds={completedStepIds}
                                        onStepClick={onStepClick}
                                        orientation='horizontal'
                                    />
                                </div>
                            )}

                            <div className='bpWizard-appWrapper-content'>
                                <div className='bpWizard-childWrapper'>
                                    <div className='bpWizard-childWidth'>
                                        <div style={{ paddingLeft: '20px' }}>
                                            <header className='bpWizard-header'
                                                style={{ marginTop: '0.75rem', marginBottom: '0.75rem' }}>
                                                {heading}
                                            </header>
                                            {children}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {footer && <div className='bpWizard-appWrapper-navigationButtons'>{footer}</div>}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};
